import React, { useState, useEffect } from "react";

const LogoSkeleton = () => {
  return (
    <>
      <style>
        {`
          @keyframes shimmer {
            0% {
              background-position: -1000px 0;
            }
            100% {
              background-position: 1000px 0;
            }
          }
        `}
      </style>
      <div
        style={{
          width: "100%",
          height: "55px",
          borderRadius: "6px",
          backgroundColor: "#eee",
          backgroundImage:
            "linear-gradient(to right, #eee 0%, #ddd 50%, #eee 100%)",
          backgroundSize: "1000px 100%",
          backgroundRepeat: "no-repeat",
          animation: "shimmer 2s infinite linear",
        }}
      ></div>
    </>
  );
};

const LogoWithSkeleton = ({ logoImage,loading }) => {
  const [logoLoading, setLogoLoading] = useState(false);

  useEffect(() => {
    setLogoLoading(false); 
  }, [logoImage]);

  return (
    <div style={{ width: "100%", height: "55px" }}>
      {loading && <LogoSkeleton />}
      <img
        src={logoImage}
        onLoad={() => setLogoLoading(false)}
        onError={() => setLogoLoading(false)}
        alt="logo"
        style={{
          width: "100%",
          height: "55px",
          objectFit: "contain",
          objectPosition: "center",
          display: logoLoading ? "none" : "block",
        }}
      />
    </div>
  );
};

export default LogoWithSkeleton;
